import { KeyToValueOfType } from '@paragon/utilities';

/** Global-listener order for passive monitoring listeners. Comfortably above the orders
 *  feature listeners use (2, 1, 0, -1), so counting runs before any listener that returns
 *  false to stop propagation and can never be starved by one. */
export const MONITORING_LISTENER_ORDER = 1000;

export const LEFT_MOUSE_BUTTON = 1;
export const MIDDLE_MOUSE_BUTTON = 4;

/**
 * like `MouseEvent.buttons` but with emulation for touch events.
 */
export function getMouseButtons(event: MouseEvent | TouchEvent): number {
  if (event instanceof MouseEvent) return event.buttons;

  // Touch events with a single touch are emulated as mouse events. We have to pretend that 0 === 1 because, as a wise
  //   man once said, "Mobile Safari is the new Internet Explorer."
  if (window.TouchEvent && event instanceof TouchEvent && event.touches.length < 2) {
    return LEFT_MOUSE_BUTTON;
  }

  return 0;
}

/**
 * returns the average position of the given property of the given touches.
 */
export function averagePosition(items: Touch[], property: KeyToValueOfType<Touch, number>): number {
  return items.map((item) => item[property]).reduce((sum, value) => sum + value) / items.length;
}
